













































































































import { defineEmits, defineProps, withDefaults } from "@vue/runtime-dom";
import { computed, ref, watch } from "@vue/composition-api";
import { useFinancePaymentModal } from "@/stores/webmaster/finance/modal/financePaymentModal";
import { storeToRefs } from "pinia";
import FinancePaymentListItem from "@/components/Webmaster/Finance/modal/FinancePaymentModal/FinancePaymentListItem.vue";
import { Requisite } from "@core/store/types/webmaster/finances/modal/financeRequisites";
import { useUser } from "@/stores/common/profile/user";
import LLoading from "@/components/Common/LLoading.vue";
import { filteredDataBySearch } from "@core/helpers/filteredDataBySearch";
interface Props {
  items?: Requisite[] | null;
  value?: string | null;
  label?: string;
  disabled?: boolean | ((item: any) => boolean);
  withFilters?: boolean;
  hasStatus?: boolean;
  disabledTooltip?: string | ((item: any) => string);
  loadingItemId: string | null;
}
const __sfc_main = {};
__sfc_main.props = {
  items: {
    key: "items",
    required: false,
    type: [Array, null],
    default: null
  },
  value: {
    key: "value",
    required: false,
    type: [String, null],
    default: null
  },
  label: {
    key: "label",
    required: false,
    type: String,
    default: ""
  },
  disabled: {
    key: "disabled",
    required: false,
    type: [Boolean, Function],
    default: () => false
  },
  withFilters: {
    key: "withFilters",
    required: false,
    type: Boolean,
    default: false
  },
  hasStatus: {
    key: "hasStatus",
    required: false,
    type: Boolean,
    default: true
  },
  disabledTooltip: {
    key: "disabledTooltip",
    required: false,
    type: [String, Function],
    default: () => ""
  },
  loadingItemId: {
    key: "loadingItemId",
    required: false,
    type: [String, null],
    default: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const financePaymentModalStore = useFinancePaymentModal();
  const {
    currentTab
  } = storeToRefs(financePaymentModalStore);
  const isCollapsed = ref(false);
  const name = ref("");
  const filteredItems = ref(props.items);
  const selectedItem = computed(() => {
    return props.items?.find((item: Requisite) => item.id === props.value) || {};
  });
  function selectItem(event: Requisite) {
    emit("select", event);
  }
  const MAX_HEIGHT_PX = 370;
  function beforeEnter(el: HTMLElement) {
    el.style.opacity = "0";
    el.style.maxHeight = "0px";
    el.style.overflow = "hidden";
  }
  function enter(el: HTMLElement, done: () => void) {
    const scrollHeight = el.scrollHeight;
    const targetHeight = Math.min(scrollHeight, MAX_HEIGHT_PX);
    el.style.transition = "max-height 0.4s ease, opacity 0.4s ease";
    el.style.maxHeight = targetHeight + "px";
    el.style.opacity = "1";
    el.addEventListener("transitionend", () => {
      el.style.maxHeight = "";
      el.style.overflow = "auto"; // оставить скролл
      done();
    }, {
      once: true
    });
  }
  function leave(el: HTMLElement, done: () => void) {
    el.style.maxHeight = el.scrollHeight + "px";
    el.style.opacity = "1";
    void el.offsetHeight;
    el.style.transition = "max-height 0.4s ease, opacity 0.4s ease";
    el.style.maxHeight = "0px";
    el.style.opacity = "0";
    el.addEventListener("transitionend", () => {
      el.style.overflow = "hidden";
      done();
    }, {
      once: true
    });
  }
  watch(() => props.items, value => {
    filteredItems.value = value;
  });
  watch(() => props.value, value => {
    if (!value && isCollapsed.value && (filteredItems.value?.length ?? 0) > 2) {
      isCollapsed.value = false;
    }
    if (value && !isCollapsed.value && (filteredItems.value?.length ?? 0) > 2) {
      isCollapsed.value = true;
    }
  });
  return {
    useUser,
    filteredDataBySearch,
    emit,
    currentTab,
    isCollapsed,
    name,
    filteredItems,
    selectedItem,
    selectItem,
    beforeEnter,
    enter,
    leave
  };
};
__sfc_main.components = Object.assign({
  FinancePaymentListItem,
  LLoading
}, __sfc_main.components);
export default __sfc_main;
